<template>
    <div class="content">
        <h2>ELIGIBLE EXPENSES</h2>
        <h4>Expenses incurred in the treatment of a covered Illness or Injury which are Medically Necessary and not exceeding the limits in Schedule A - Benefit Coverage. </h4>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.content {
  width: 100%;
  margin: auto;
  padding: 10px;
}
.content h2 {
  font-size: 16px;
  text-align: justify;
  color: #1b5e20;
}
.content h4 {
  font-weight: normal;
  font-size: 13px;
  text-align: justify;
  padding-left: 10px;
}
.content ul li {
  font-size: 13px;
  margin-top: 10px;
  list-style: none;
  text-align: justify;
}
@media (max-width: 599px) {
  .content {
    width: 90%;
    margin-top: 10px;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .content {
   
    width: 80%;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  .content {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .content {
    width: 100%;
  }
}
</style>
